<modal id="coolOffModal" class="modal_smooth_open cool-off-modal">
    <div class="fixed-scroll">
        <div class="site_modal middleAlignBlock">
            <div class="middleAlign">
                <div class="site_modal--body site_modal--body-small">

                    <div class="modal__container">
                        <div class="modal__heading">

                            <h3>{{'coolOffModalComp.title' | translate}}</h3>

                        </div>
                        <div class="modal__body">
                            <p>{{'coolOffModalComp.description' | translate}}</p>

                            <div class="break-info-list">
                                <p>{{'coolOffModalComp.pointsTitle' | translate}}</p>

                                <ul>
                                    <li *ngFor="let point of coolOffPoints">
                                        {{ point | translate }}
                                    </li>
                                </ul>
                            </div>
                            <p>{{'coolOffModalComp.warning' | translate}}</p>

                            <p>{{'coolOffModalComp.confirmation' | translate}}</p>

                            <div class="modal__body--btn">   
                                <button class="site-btn site-btn--xm site-btn__teritary-outline" (click)="confirmCoolOff()">
                                   {{'coolOffModalComp.confirm' | translate}}
                                </button>
                                <button class="site-btn site-btn--xm site-btn__primary" (click)="closeCoolOffModal()">
                                    {{'coolOffModalComp.cancel' | translate}}
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</modal>